import { defineWidgetSettings } from "@nexus/widget-sdk";
import { ANIMATE_VALUE_CONFIG } from "@nexus/widget-kit";
import { BREAKDOWNS } from ".";

/** What an author sets on the safe-to-block summary. */
export const settings = defineWidgetSettings({
  id: "safe-to-block",
  extends: [ANIMATE_VALUE_CONFIG],
  properties: {
    breakdown: {
      type: "string",
      title: "Breakdown",
      description:
        "Rows under the safety bar: Web and IPTV safety, or the share approved by the regulator",
      default: "channels",
      oneOf: BREAKDOWNS.map((option) => ({ const: option.value, title: option.label })),
      "x-ui": { category: "data", order: 10 },
    },
    showValues: {
      type: "boolean",
      title: "Show values",
      description: "Safe IP or domain counts in place of the percentages under the bars",
      default: false,
      "x-ui": { category: "display", order: 10, visibleIf: { breakdown: { not: "approved" } } },
    },
  },
});
